import { useParams } from "react-router";

import ErrorBoundary from "@/components/error-boundary";
import SolveAssignmentForm from "@/components/forms/solve-assignment-form";
import { SOLVE_FEATURE } from "@/lib/error-tracking";

const SolveAssignmentPage = () => {
  const { assignmentId, courseId } = useParams<{
    assignmentId: string;
    courseId: string;
  }>();

  return (
    // 풀이 화면 렌더 크래시는 화이트스크린 대신 폴백 UI를 보여주고, 과제 컨텍스트
    // 태그와 함께 Sentry로 보고한다.
    <ErrorBoundary tags={{ feature: SOLVE_FEATURE, assignmentId, courseId }}>
      <div>
        <SolveAssignmentForm />
      </div>
    </ErrorBoundary>
  );
};

export default SolveAssignmentPage;
